import { CartItem } from "@/store/CartStore";
import { MenuItem, RestaurantMenu } from "./useMenu";
import { UpsaleConfig } from "@/providers/LocationConfigurationProvider";
import { useMemo } from "react";

/**
 * Given a cart, returns upsales for a location
 */
export const useUpsales = (
  cart: CartItem[],
  menus: RestaurantMenu[],
  upsales: UpsaleConfig[] | undefined,
) => {
  const categories = useMemo(() => {
    if (menus) {
      return menus.flatMap((menu) => menu.categories);
    }

    return [];
  }, [menus]);

  const nonUpsalesInCart = cart.filter((item) => !item.isUpsale) ?? [];

  const productIdsInCart = nonUpsalesInCart.reduce((acc, item) => {
    if (!acc.includes(item.productId)) {
      acc.push(item.productId);
    }
    return acc;
  }, [] as string[]);

  const categoriesInCart = productIdsInCart.reduce((acc, productId) => {
    const product = categories
      .flatMap((c) => c.products)
      .find((p) => p.id === productId);
    if (product && !acc.includes(product.categoryId)) {
      acc.push(product.categoryId);
    }
    return acc;
  }, [] as string[]);

  const upsalesForCart = upsales?.filter((upsale) => {
    if (
      upsale.categoryIds[0] === "*" &&
      !categoriesInCart.includes(upsale.categoryToUpsellId)
    )
      return true;
    return categoriesInCart.some((id) => upsale.categoryIds.includes(id));
    //&& !categoriesInCart.includes(upsale.categoryToUpsellId)
  });

  const upsaleCategoriesWithProducts = upsalesForCart?.reduce(
    (acc, upsale) => {
      const category = categories.find(
        (c) => c.id === upsale.categoryToUpsellId,
      );
      if (category) {
        acc.push({
          ...category,
        });
      }
      return acc;
    },
    [] as { id: string; name: string; products: MenuItem[] }[],
  );

  const upsaleProducts =
    upsaleCategoriesWithProducts
      ?.flatMap((category) => category.products)
      .filter((product) => product.unavailable !== true) ?? [];

  const hasUpsale = (upsaleProducts ?? [])?.length > 0;

  return {
    hasUpsale,
    upsalesForCart,
    upsaleCategoriesWithProducts,
    upsaleProducts,
  };
};
